import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '@stores/store';
import { io, Socket } from 'socket.io-client';

export type TSocketInitialState = {
  socket: Socket;
  isConnected: boolean;
};

const initialState: Partial<TSocketInitialState> = {
  isConnected: false,
};

export const socketSelector = (state: RootState) => state.socket;

export const popupSlice = createSlice({
  name: 'socket',
  initialState,
  reducers: {
    connectSocket: (state, action) => {
      const { socketIo } = action.payload;
      if (state.socket?.id) {
        state.socket.disconnect();
      }
      state = {
        ...state,
        socket: socketIo,
      };
      return state;
    },
    disconnectSocket: (state, action) => {
      if (state.socket) {
        state.socket.disconnect();
        state.socket = undefined;
      }
      return state;
    },
  },
});

export const { connectSocket, disconnectSocket } = popupSlice.actions;

export default popupSlice.reducer;
